var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ValidationProvider',{ref:"provider",attrs:{"name":_vm.name,"rules":_vm.rules,"slim":""},scopedSlots:_vm._u([{key:"default",fn:function(ref){
var errors = ref.errors;
return [_vm._t("default",[_c('span',{staticClass:"red--text",attrs:{"value":errors.length > 0}},[_vm._v("\n      "+_vm._s(errors[0])+"\n    ")])],{"errors":errors})]}}],null,true)})}
var staticRenderFns = []

export { render, staticRenderFns }